import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { withTimeout } from "@/lib/supabaseAuthStability";

export const useAdminCheck = () => {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }
      try {
        const { data, error } = await withTimeout(
          supabase.rpc("has_role", {
            _user_id: user.id,
            _role: "admin",
          }),
          5000,
          "Tempo esgotado ao verificar permissões."
        );
        setIsAdmin(!!data && !error);
      } catch (error) {
        console.warn("[Auth] Falha ao verificar admin", error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };
    check();
  }, [user]);

  return { isAdmin, loading };
};
